const getters = {
  /**
 * @function  getComponentGroupedParent
 * @param {string} - componentName - Component name
 * Get the component parent if the component is grouped in the product data Model
 */
  getComponentGroupedParent(state) {
    return (componentName) => {
      let componentParentName;
      const group = state.componentsParentChildConfiguration;
      const keys = Object.keys(group);
      keys.forEach(parentComponent => {
        if (group[parentComponent].includes(componentName)) {
          componentParentName = parentComponent;
        }
      });
      return componentParentName;
    };
  }
};
export default getters;